import { useEffect, useRef } from "react";

/**
 * Return value gives a reference to the previous value of an element (eg: a prop).
 * Makes it possible to compare previous and old value using hooks.
 *
 * @param value the value to keep track of
 */
export const usePrevious = (value: any) => {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
};
